module.exports = __webpack_public_path__ + "img/28Wilson.f596a641.png";